import { ShiftBlockOption } from '../models/shiftblock-option.model';
import { ShiftBlockType } from 'src/shared/models/shift-schedule.model';
import { StartHour } from '../models/start-hour.model';

export enum StaffingGridConfiguration {
    Acuity,
    Inpatient,
    TotalUos
}

export enum StaffingGridType {
    None,
    AllWeekAddOns,
    AllWeekFixed,
    AllWeekVariable,
    SaturdayAddOns,
    SaturdayFixed,
    SaturdayVariable,
    SundayAddOns,
    SundayFixed,
    SundayVariable,
    WeekdayAddOns,
    WeekdayFixed,
    WeekdayVariable,
    WeekendAddOns,
    WeekendFixed,    
    WeekendVariable
}


export class StaffingGridConstants {    
    static readonly AllWeekAddOns = 'All Week Add Ons';
    static readonly AllWeekFixed = 'All Week Fixed';
    static readonly AllWeekType: ShiftBlockOption = { description: "All Week", id: ShiftBlockType.AllWeek };
    static readonly AllWeekVariable = 'All Week Variable';    
    static readonly DefaultShiftBlockLength = 4;
    static readonly SaturdayAddOns = 'Saturday Add Ons';
    static readonly SaturdayFixed = 'Saturday Fixed';
    static readonly SaturdayOnlyType: ShiftBlockOption = { description: "Saturday Only", id: ShiftBlockType.Saturday };
    static readonly SaturdayVariable = 'Saturday Variable';
    static readonly SelectShiftBlockType: ShiftBlockOption = { description: "Select", id: -999 };
    static readonly SundayAddOns = 'Sunday Add Ons';
    static readonly SundayFixed = 'Sunday Fixed';
    static readonly SundayOnlyType: ShiftBlockOption = { description: "Sunday Only", id: ShiftBlockType.Sunday };
    static readonly SundayVariable = 'Sunday Variable';
    static readonly WeekdayAddOns = 'Weekday Add Ons';
    static readonly WeekdayFixed = 'WeekdayFixed'; 
    static readonly WeekdayType: ShiftBlockOption = { description: "Weekday", id: ShiftBlockType.Weekday };   
    static readonly WeekdayVariable = 'WeekdayVariable';
    static readonly WeekendAddOns = 'Weekend Add Ons';
    static readonly WeekendFixed = 'WeekendFixed';
    static readonly WeekendType: ShiftBlockOption = { description: "Weekend", id: ShiftBlockType.Weekend };
    static readonly WeekendVariable = 'WeekendVariable';
    static readonly emptyStartHour: StartHour = { description: '-', hour: -999};

    static readonly ShiftBlockOptions: ShiftBlockOption[] = [ 
        StaffingGridConstants.SelectShiftBlockType, 
        StaffingGridConstants.WeekdayType, 
        StaffingGridConstants.WeekendType, 
        StaffingGridConstants.AllWeekType, 
        StaffingGridConstants.SaturdayOnlyType, 
        StaffingGridConstants.SundayOnlyType 
    ];

    static readonly shiftBlockHours: StartHour[] = [
        StaffingGridConstants.emptyStartHour,
        { description: '12am', hour: 0 },
        { description: '1am', hour: 1 },
        { description: '2am', hour: 2 },
        { description: '3am', hour: 3 },
        { description: '4am', hour: 4 },
        { description: '5am', hour: 5 },
        { description: '6am', hour: 6 },
        { description: '7am', hour: 7 },
        { description: '8am', hour: 8 },
        { description: '9am', hour: 9 },
        { description: '10am', hour: 10 },
        { description: '11am', hour: 11 },
        { description: '12pm', hour: 12 },
        { description: '1pm', hour: 13 },
        { description: '2pm', hour: 14 },
        { description: '3pm', hour: 15 },
        { description: '4pm', hour: 16 },
        { description: '5pm', hour: 17 },
        { description: '6pm', hour: 18 },
        { description: '7pm', hour: 19 },
        { description: '8pm', hour: 20 },
        { description: '9pm', hour: 21 },
        { description: '10pm', hour: 22 },
        { description: '11pm', hour: 23 },
    ];
}